   <template>
  
        <div class="container py-4">
      <div class="card shadow-sm  rounded-5">
        <div class="card-body text-center p-4">
           <slot name="image" :object="object"></slot>
        
           <h1 class="display-6 text-center text-success">{{ object.title }}</h1>
           
            <div class="fs-5 mb-4 text-center">
                 {{ object.description }}
            </div>
        
        
        
        </div>
      </div>
    </div>

      

</template>


<script>


export default {
  props: ['object'],
 
  
  methods: {}
};
</script>


<style scoped>

.card {
  border: 1px solid white; /*light green background  #d4eadd*/
  background-color: white; /* light green background  #f9fdfb*/
}



</style>